/* TLB 2026-09-30 v2: trang xac nhan email marketing cua Shopify. Chi them dau tich (khi da huy dang ky) va nut Back to shop; khong gui du lieu di dau. */
(function(){
  function run(){
    var c=document.querySelector('.shopify-email-marketing-confirmation__container');
    if(!c||c.querySelector('.tlb-unsub-btn'))return;
    if(c.textContent.indexOf('unsubscribed from our mailing list')>-1)c.classList.add('tlb-unsub-ok');
    var a=document.createElement('a');
    a.className='tlb-unsub-btn';
    a.href='/';
    a.textContent='Back to shop';
    c.appendChild(a);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
